import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "pointer-events-auto rounded-lg bg-white shadow-lg" }
const _hoisted_2 = { class: "overflow-hidden rounded-lg shadow-xl" }
const _hoisted_3 = { class: "p-4" }
const _hoisted_4 = { class: "flex items-start" }
const _hoisted_5 = {
  key: 0,
  class: "shrink-0"
}
const _hoisted_6 = { class: "ml-3 w-0 flex-1 pt-0.5" }
const _hoisted_7 = {
  key: 0,
  class: "text-sm font-medium leading-5 text-gray-900"
}
const _hoisted_8 = { class: "ml-4 flex shrink-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SuccessIcon = _resolveComponent("SuccessIcon")!
  const _component_InfoIcon = _resolveComponent("InfoIcon")!
  const _component_WarningIcon = _resolveComponent("WarningIcon")!
  const _component_ErrorIcon = _resolveComponent("ErrorIcon")!
  const _component_CloseIcon = _resolveComponent("CloseIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.notification.type)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_ctx.notification.type === 'success')
                  ? (_openBlock(), _createBlock(_component_SuccessIcon, { key: 0 }))
                  : (_ctx.notification.type === 'info')
                    ? (_openBlock(), _createBlock(_component_InfoIcon, { key: 1 }))
                    : (_ctx.notification.type === 'warning')
                      ? (_openBlock(), _createBlock(_component_WarningIcon, { key: 2 }))
                      : (_ctx.notification.type === 'error')
                        ? (_openBlock(), _createBlock(_component_ErrorIcon, { key: 3 }))
                        : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            (_ctx.notification.title)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.notification.title), 1))
              : _createCommentVNode("", true),
            _createElementVNode("p", {
              class: _normalizeClass(`${_ctx.notification.title ? 'mt-1' : ''} text-sm leading-5 text-gray-500`)
            }, _toDisplayString(_ctx.notification.content), 3)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = () => _ctx.closeNotification(_ctx.notification.id)),
              class: "inline-flex text-gray-400 focus:text-gray-500 focus:outline-none"
            }, [
              _createVNode(_component_CloseIcon)
            ])
          ])
        ])
      ])
    ])
  ]))
}